import {useCache} from './use_cache'

export const usePinnedColumns = ({tableName}) => {
	return useCache({tableName}).pinned || []
}
